import React from 'react'
import { BsCaretDownFill, BsFillCaretUpFill } from 'react-icons/bs';

const Delta: React.FC<{ isPositive: boolean, className?: string }> = ({ isPositive, className }) => {
  return (
    <span className={className} style={{ verticalAlign: "middle" }}>
      {typeof isPositive === "boolean" ? ( isPositive ? (
          <BsFillCaretUpFill style={{ fontSize: "1.2em", marginBottom: "2px" }} />
      ) : (
          <BsCaretDownFill style={{ fontSize: "1.2em", marginBottom: "2px" }} />
      )): ""}
    </span>
  )
}

export default Delta;